/**
 * URL Utilities
 *
 * Common utility functions for URL manipulation and favicon retrieval.
 */
/**
 * Get favicon URL for a given website URL using Google's favicon service.
 *
 * @param url - The website URL to get favicon for
 * @param size - Optional size in pixels (default is Google's default ~16px)
 * @returns Google favicon service URL
 *
 * @example
 * ```ts
 * getFaviconUrl("https://github.com") // "https://www.google.com/s2/favicons?domain=https://github.com"
 * getFaviconUrl("https://github.com", 32) // "https://www.google.com/s2/favicons?domain=https://github.com&sz=32"
 * ```
 */
export function getFaviconUrl(url, size) {
    const resultUrl = `https://www.google.com/s2/favicons?domain=${url}`;
    if (size) {
        return `${resultUrl}&sz=${size}`;
    }
    return resultUrl;
}
/**
 * Extract hostname from a URL string.
 *
 * @param url - The URL to extract hostname from
 * @param fallback - Fallback value if URL is invalid (default: returns the original url)
 * @returns The hostname or fallback value
 *
 * @example
 * ```ts
 * getHostname("https://www.example.com/path") // "www.example.com"
 * getHostname("invalid-url") // "invalid-url"
 * getHostname("invalid-url", "Unknown") // "Unknown"
 * ```
 */
export function getHostname(url, fallback) {
    try {
        return new URL(url).hostname;
    }
    catch {
        return fallback ?? url;
    }
}
